'use strict';

module.exports = [function () {
        return function (input, callback) {
            callback = callback || function (company) {
                return company.name;
            };
            return callback(input);
        };
    }];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/filters/CompanyFilter.js
// module id = 402
// module chunks = 0